import type { ProviderOutcomes } from "../../providers/providers.types";
import type { Clinic, ClinicSuccessRates } from "../clinics.types";
import { parsePublishedPercentage } from "../../cdc-art/registry";

type PublishedRate = ProviderOutcomes["successRates"][number];

export function isPublishedOutcomeRate(rate: PublishedRate): boolean {
  return Number.isFinite(rate.rate) && rate.rate >= 0 && rate.rate <= 100;
}

/** Preserve source groups; a combined >40 rate is not an over-42 rate. */
export function providerClinicRates(
  outcomes: Pick<ProviderOutcomes, "successRates"> | undefined,
): Pick<Clinic, "successRates" | "successRateDenominators"> {
  const rates: ClinicSuccessRates = {};
  const denominators: ClinicSuccessRates = {};
  for (const [ageBand, key] of [
    ["<35", "under35"],
    ["35-37", "between35And37"],
    ["38-40", "between38And40"],
    ["41-42", "between41And42"],
    [">42", "over42"],
  ] as const) {
    const row = outcomes?.successRates.find(
      (rate) => rate.ageBand === ageBand && isPublishedOutcomeRate(rate),
    );
    if (!row) continue;
    rates[key] = row.rate;
    const parsed = parsePublishedPercentage(row.denominator);
    if (parsed.denominator !== undefined) {
      denominators[key] = parsed.denominator;
    }
  }
  return {
    successRates: Object.keys(rates).length ? rates : undefined,
    successRateDenominators: Object.keys(denominators).length
      ? denominators
      : undefined,
  };
}
